import { isDate } from "moment";

export function isJaguar(user) {
  if(!user) {
    return false;
  }
  return user && user.role === "superadmin" || user.role === "jaguar";
}

export function isSuperadmin(user) {
  return user.role === "superadmin";
}

export function hasWarehouseAccess(user) {
  return user.role === "superadmin";
}

export function isClient(user) {
  return user.role === "client";
}

export function canEditEvent(event,user) {
  if(!event || !user) {
    return false;
  }
  if(event.renters && user.renters) {
    const event_renter_ids = event.renters.map(x=>x.id);
    const user_renter_ids = user.renters.map(x=>x.id);
    return event_renter_ids.filter(x=> user_renter_ids.indexOf(x) > -1).length > 0;
  }
}

export function hasClientAccess(user = {}, renter = {}) {
  return isJaguar(user) || (isClient(user) && (user?.renters||[]).map(x=>x.id).indexOf(renter.id) > -1);
}

export function canUserAddItemToEvent(user={}, item={}) {
  if(item.for_sale) {
    return false
  }
  return isJaguar(user) || hasClientAccess(user, item.renter) || (item.renter_id === null && item.public && isClient(user));
}

export function canUserAddItemToCart(user={}, item={}) {
  return isJaguar(user) || hasClientAccess(user, item.renter);
}



export function canEditItem(item = {},user = {}) {
  if(!user.id) {
    return false
  }
  if(isJaguar(user)) {
    return true;
  }
  if(!item || !user) {
    return false;
  }
  if(item.renter_id && user.renters) {
    const item_renter_id = item.renter_id
    const user_renter_ids = user.renters.map(x=>x.id);
    return user_renter_ids.indexOf(item_renter_id) > -1;
  }
}
